import React, { useEffect, useState } from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import { toast } from "react-toastify";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AddButton, SearchToggleButton, } from "../../../utils/Custom/Button";
import { submitSiteDelete } from "../../../utils/commonComponent/delete";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
import ListView from "../../../utils/Custom/listView";
import { Autocomplete, Button, Checkbox, createFilterOptions, Grid, TextField, } from "@mui/material";
import { getPermissions } from "../rbac/hasAccess";
import NABLHeader from "../../image/header.png";
import NONABLHeader from "../../image/header.png";
import Footer from "../../image/footer.jpeg";
import LoaderModal from "../../../utils/loader/loader";
import { calculateAvailableBalance, fetchPrivilegedLeaveByEmployee, leaveTypeOptions, weekOffs } from "./applyLeave";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { branchOptions, departmentOptions, } from "../employeeMaster/employeeConstants";

const MS_IN_DAY = 1000 * 60 * 60 * 24;

const headers = [
  "id",
  "employeeName",
  "employeesCode",
  "dateOfJoining",
  "leaveType",
  "fromDate",
  "toDate",
  "opening",
  "balance",
];

let config = {
  margin: 15,
  borderMagin: 7,
  headerImgHeight: 70,
  headerTableHeight: 25,
  headerTitleHeight: 15,
  footerImgHeight: 70,
  footerTableHeight: 50,
  fontSize: 9,
  cusotmerHeight: 50,
  bordergap: 5,
  currentY: 0,
  footerTotalHeight: 70 + 50,
};

const statusMap = {
  0: "Pending",
  1: "Pending",
  2: "Approved",
  3: "Rejected",
};

const filter = createFilterOptions();
const LeaveBalanceReport = (props) => {
  const getStartOfCurrentYear = () => {
    const now = new Date();
    return new Date(now.getFullYear(), 0, 1); // Jan 1
  };

  const getToday = () => new Date();

  const navigate = useNavigate();
  const permissions = getPermissions(props.moduleId);
  const handleDelete = (row) => submitSiteDelete("leaveManagement", row.id);

  const [leaveManagementList, setLeaveManagementList] = useState([]);
  const [employeesData, setEmployeesData] = useState([]);
  const [inputStates, setInputStates] = React.useState({
    fromDate: getStartOfCurrentYear(),
    toDate: getToday(),
    approveStatus: 2,
  });
  const [searched, setSearched] = React.useState(false);
  const [letterHead, setLetterHead] = React.useState(true);
  const [loading, setLoading] = useState(false);
  const _employeeId = Number(localStorage.getItem("employeeId"));
  const _userType = Number(localStorage.getItem("type"));

  const updateInputObject = (key, value) => {
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));
    setSearched(false);
  };

  const getQuery = () => {
    const conditions = ["e.status = 1"];

    // ✅ employee filter (employees table only)
    if (
      Array.isArray(inputStates?.employeeIds) &&
      inputStates.employeeIds.length
    ) {
      conditions.push(`e.id IN (${inputStates.employeeIds.join(",")})`);
    }

    const joinConditions = ["lm.employeeId = e.id", "lm.status = 1"];

    // ✅ leave type filter (JOIN level)
    if (
      Array.isArray(inputStates?.leaveTypes) &&
      inputStates.leaveTypes.length
    ) {
      const leaveTypesStr = inputStates.leaveTypes
        .map((lt) => `'${lt}'`)
        .join(",");
      joinConditions.push(`lm.leaveType IN (${leaveTypesStr})`);
    }

    // ✅ approve status filter (JOIN level)
    if (inputStates?.approveStatus) {
      const s = Number(inputStates.approveStatus);
      if (s === 3)
        joinConditions.push(
          `(lm.approveManagerStatus=3 OR lm.approveLevel1=3 OR lm.approveLevel2=3)`
        );
      else if (s === 2)
        joinConditions.push(
          `(lm.approveManagerStatus!=3 AND lm.approveLevel1!=3 AND lm.approveLevel2!=3 AND (lm.approveManagerStatus=2 OR lm.approveLevel1=2 OR lm.approveLevel2=2))`
        );
      else if (s === 1)
        joinConditions.push(
          `(lm.approveManagerStatus NOT IN (2,3) AND lm.approveLevel1 NOT IN (2,3) AND lm.approveLevel2 NOT IN (2,3))`
        );
    }

    // ✅ date filter (JOIN level)
    if (inputStates?.fromDate && inputStates?.toDate) {
      const f = new Date(inputStates.fromDate);
      const t = new Date(inputStates.toDate);
      const fISO = new Date(
        f.getFullYear(),
        f.getMonth(),
        f.getDate(),
        0,
        0,
        0
      ).toISOString();
      const tISO = new Date(
        t.getFullYear(),
        t.getMonth(),
        t.getDate(),
        23,
        59,
        59
      ).toISOString();
      joinConditions.push(`lm.fromDate BETWEEN '${fISO}' AND '${tISO}'`);
    }

    const whereClause = conditions.length
      ? `WHERE ${conditions.join(" AND ")}`
      : "";
    const joinClause = joinConditions.join(" AND ");

    return `SELECT e.id AS employeeId,e.employeesCode,e.name AS employeeName,e.gender,e.dateOfJoining,lm.id,lm.documentNo,lm.applyLeaveDate,lm.leaveType,lm.leaveBalance,lm.fromDate,lm.toDate,lm.fromLeaveValue,lm.toLeaveValue,lm.remark,lm.docUrl,lm.approveManagerStatus,lm.reasonStatus,lm.rejectRemark,lm.approveLevel1,lm.approveLevel2,eod.appprovalManagerId,CONCAT(em1.name,' (',em1.employeesCode,')') AS approvalManagerEmployee,eod.approvalLevel1Id,CONCAT(em2.name,' (',em2.employeesCode,')') AS approvalLevel1Employee,eod.approvalLevel2Id,CONCAT(em3.name,' (',em3.employeesCode,')') AS approvalLevel2Employee FROM employees e LEFT JOIN leaveManagement lm ON ${joinClause} LEFT JOIN employeeOtherData eod ON e.id=eod.employeeId LEFT JOIN employees em1 ON eod.appprovalManagerId=em1.id LEFT JOIN employees em2 ON eod.approvalLevel1Id=em2.id LEFT JOIN employees em3 ON eod.approvalLevel2Id=em3.id ${whereClause} ORDER BY e.id DESC,lm.id DESC;`;
  };

  const formatDate = (date) =>
    date ? new Date(date).toLocaleDateString("en-GB") : "";

  const getDaysBetween = (
    fromDate,
    toDate,
    fromLeaveValue = "",
    toLeaveValue = ""
  ) => {
    if (!fromDate || !toDate) return 0;

    const start = new Date(fromDate);
    const end = new Date(toDate);

    if (isNaN(start) || isNaN(end)) return 0;

    // Calculate normal day difference
    let applyingDays = Math.abs(Math.floor((end - start) / MS_IN_DAY)) + 1;

    // ----- Half Day Logic -----
    if (start.toDateString() === end.toDateString()) {
      // Single day leave
      if (
        fromLeaveValue === "First Half Day" ||
        fromLeaveValue === "Second Half Day"
      ) {
        applyingDays = 0.5;
      }
    } else {
      // Multi-day leave

      if (
        fromLeaveValue === "First Half Day" ||
        fromLeaveValue === "Second Half Day"
      ) {
        applyingDays -= 0.5;
      }

      if (
        toLeaveValue === "First Half Day" ||
        toLeaveValue === "Second Half Day"
      ) {
        applyingDays -= 0.5;
      }
    }

    return applyingDays;
  };

  const fetchData = async () => {
    try {
      /* -------------------------------------------------- */
      /* 1️⃣ Fetch leave data */
      /* -------------------------------------------------- */
      const query = getQuery();
      const leaveManagement = await fetchQuery(query);

      /* -------------------------------------------------- */
      /* 2️⃣ Normalize leave records */
      /* -------------------------------------------------- */
      const updatedLeaveManagement = leaveManagement.map((item) => {
        const statuses = [
          Number(item.approveManagerStatus),
          Number(item.approveLevel1),
          Number(item.approveLevel2),
        ];

        const leaveStatus = statuses.includes(3)
          ? statusMap[3]
          : statuses.includes(2)
            ? statusMap[2]
            : statusMap[0];

        return {
          ...item,
          days: getDaysBetween(
            item.fromDate,
            item.toDate,
            item.fromLeaveValue,
            item.toLeaveValue
          ),
          leaveStatus,
        };
      });

      /* -------------------------------------------------- */
      /* 3️⃣ Build employee map */
      /* -------------------------------------------------- */
      const employeeMap = {};

      updatedLeaveManagement.forEach((item) => {
        if (!employeeMap[item.employeeId]) {
          employeeMap[item.employeeId] = {
            employeeId: item.employeeId,
            employeeName: item.employeeName,
            employeesCode: item.employeesCode,
            gender: item.gender,
            dateOfJoining: formatDate(item.dateOfJoining),
            fromDate: formatDate(inputStates.fromDate),
            toDate: formatDate(inputStates.toDate),
            leaves: {},
          };
        }
      });

      /* -------------------------------------------------- */
      /* 4️⃣ PL CACHE (employee-wise) */
      /* -------------------------------------------------- */
      const plCache = {}; // { employeeId: totalPL }

      const getOpeningByLeaveType = async (leaveType, employeeId) => {
        const config = leaveTypeOptions.find((l) => l.name === leaveType);
        if (!config) return 0;

        // 🔵 DYNAMIC → fetch PL per employee
        if (config.base === "DYNAMIC") {
          if (plCache[employeeId] === undefined) {
            const plData = await fetchPrivilegedLeaveByEmployee(employeeId);
            plCache[employeeId] = plData?.totalPL || 0;
          }
          return plCache[employeeId];
        }

        // 🔴 Static base
        return Number(config.base) || 0;
      };

      /* -------------------------------------------------- */
      /* 5️⃣ Initialize leaves (Casual Leave = Unlimited) */
      /* -------------------------------------------------- */
      for (const emp of Object.values(employeeMap)) {
        for (const lt of leaveTypeOptions) {
          if (lt.gender !== "Both" && lt.gender !== emp.gender) continue;

          // ✅ Casual Leave → Unlimited Paid
          if (lt.name === "Casual Leave") {
            emp.leaves[lt.name] = {
              leaveType: lt.name,
              opening: "-",
              usedDays: "-",
              balance: "-",
            };
            continue;
          }

          // 🔵 Other leave types
          const opening = await getOpeningByLeaveType(lt.name, emp.employeeId);

          emp.leaves[lt.name] = {
            leaveType: lt.name,
            opening,
            usedDays: 0,
            balance: 0,
          };
        }
      }

      /* -------------------------------------------------- */
      /* 6️⃣ Add used days */
      /* -------------------------------------------------- */
      updatedLeaveManagement.forEach((item) => {
        const emp = employeeMap[item.employeeId];
        if (emp?.leaves[item.leaveType]) {
          emp.leaves[item.leaveType].usedDays += Number(item.days || 0);
        }
      });

      /* -------------------------------------------------- */
      /* 7️⃣ Calculate balance (skip unlimited leaves) */
      /* -------------------------------------------------- */
      Object.values(employeeMap).forEach((emp) => {
        Object.values(emp.leaves).forEach((l) => {
          // ✅ Unlimited leave (Casual Leave)
          if (l.opening === "-") {
            l.balance = "-";
            return;
          }

          l.balance = Math.max(
            Number(l.opening || 0) - Number(l.usedDays || 0),
            0
          );
        });
      });

      /* -------------------------------------------------- */
      /* 8️⃣ Leave-type filter */
      /* -------------------------------------------------- */
      const selectedLeaveTypes = Array.isArray(inputStates.leaveTypes)
        ? inputStates.leaveTypes
        : [];

      const employeeLeaveSummary = Object.values(employeeMap).flatMap((emp) =>
        Object.values(emp.leaves)
          .filter(
            (l) =>
              !selectedLeaveTypes.length ||
              selectedLeaveTypes.includes(l.leaveType)
          )
          .map((l) => ({
            employeeId: emp.employeeId,
            employeeName: emp.employeeName,
            employeesCode: emp.employeesCode,
            dateOfJoining: emp.dateOfJoining,
            fromDate: emp.fromDate,
            toDate: emp.toDate,
            leaveType: l.leaveType,
            opening: l.opening,
            usedDays: l.usedDays,
            balance: l.balance,
          }))
      );

      setLeaveManagementList(employeeLeaveSummary);
    } catch (error) {
      console.error("Error fetching leave data:", error);
    }
  };

  const fetchEmployeesData = async () => {
    try {
      let whereConditions = "";

      // 👤 User-type restriction
      if (_userType !== 1 && _userType !== 2 && _userType !== 8) {
        whereConditions = ` WHERE e.id = ${_employeeId}`;
      }

      // 🏢 Department condition
      if (inputStates?.department) {
        whereConditions += whereConditions
          ? ` AND eod.department = '${inputStates.department}'`
          : ` WHERE eod.department = '${inputStates.department}'`;
      }

      // 🏬 Branch condition
      if (inputStates?.branch) {
        whereConditions += whereConditions
          ? ` AND eod.branchId = '${inputStates.branch}'`
          : ` WHERE eod.branchId = '${inputStates.branch}'`;
      }

      const Employees = await fetchQuery(`
      SELECT 
        e.id, 
        e.employeesCode, 
        e.name
      FROM employees e
      LEFT JOIN employeeOtherData eod 
        ON eod.employeeId = e.id
      ${whereConditions}
    `);

      setEmployeesData(Employees);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  function addHeaderFooter(doc) {
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const headers = {
      1: NABLHeader,
      2: NONABLHeader,
    };
    const headerImage = NABLHeader;
    doc.addImage(headerImage, "PNG", 0, 0, pageWidth, config?.headerImgHeight);
    doc.addImage(
      Footer,
      "PNG",
      0,
      pageHeight - config?.footerImgHeight,
      pageWidth,
      config?.footerImgHeight
    );
  }

  const generateLeaveReport = ({
    leaveManagementList,
    headers,
    letterHead,
  }) => {
    try {
      // setLoading(true);

      requestAnimationFrame(() => {
        const doc = new jsPDF({
          orientation: "p",
          unit: "pt",
          format: "a4",
          compress: true,
        });

        // Format headers
        const formattedHeaders = headers.map((h) =>
          h === "id"
            ? "Sr. No"
            : h.replace(/([A-Z])/g, " $1").replace(/^./, (s) => s.toUpperCase())
        );

        // Prepare rows
        const tableRows = leaveManagementList.map((row, index) =>
          headers.map((key) => (key === "id" ? index + 1 : row[key] ?? ""))
        );

        // Draw table with header/footer
        autoTable(doc, {
          head: [formattedHeaders],
          body: tableRows,
          startY:
            config.headerImgHeight +
            config.headerTableHeight +
            config.headerTitleHeight +
            config.borderMagin,
          styles: {
            fontSize: config.fontSize,
            cellPadding: 4,
            fillColor: null, // remove background for all cells
            lineWidth: 0.5, // border thickness
            lineColor: 0, // black border
          },
          headStyles: {
            fillColor: null, // no header background
            textColor: 0, // black text
            halign: "center",
          },
          bodyStyles: {
            fillColor: null, // no background in body
            halign: "center",
          },
          alternateRowStyles: {
            fillColor: null, // remove alternating row background
          },
          margin: { left: config.margin, right: config.margin },
          didDrawPage: () => {
            if (letterHead) addHeaderFooter(doc);
          },
        });

        doc.save("Leave-Report.pdf");
        setLoading(false);
      });
    } catch (error) {
      console.error("Error generating PDF:", error);
      setLoading(false);
    }
  };

  const handleSearch = () => {
    if (!inputStates.employeeIds?.length) {
      toast.error("At least select one employee");
      return;
    }

    fetchData();
    setSearched(true);
  };

  const clearSearch = () => {
    setSearched(false);

    setInputStates((prev) => ({
      ...((_userType !== 1 &&
        _userType !== 2 &&
        _userType !== 8) && {
        employeeIds: prev.employeeIds,
      }),
      toDate: getToday(),
    }));

    setLeaveManagementList([]);
  };


  useEffect(() => {
    fetchEmployeesData();
  }, [inputStates?.department, inputStates?.branch]);

  useEffect(() => {
    if (
      _userType !== 1 &&
      _userType !== 2 &&
      _userType !== 8 &&
      employeesData.length > 0
    ) {
      updateInputObject("employeeIds", [employeesData[0].id]);
    }
  }, [_userType, employeesData]);

  return (
    <>
      <br />
      <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-4">
        {/* ================= ONLY FOR USER TYPE 1,2,8 ================= */}
        {[1, 2, 8].includes(_userType) && (
          <>
            {/* Department */}
            <Autocomplete
              size="small"
              fullWidth
              options={departmentOptions}
              value={
                departmentOptions.find(
                  (opt) => opt.name === inputStates.department
                ) || null
              }
              getOptionLabel={(option) => option.name}
              onChange={(e, val) =>
                updateInputObject("department", val ? val.name : "")
              }
              renderInput={(params) => (
                <TextField {...params} label="Department" />
              )}
            />

            {/* Branch */}
            <Autocomplete
              size="small"
              fullWidth
              options={branchOptions}
              value={
                branchOptions.find((opt) => opt.name === inputStates.branch) ||
                null
              }
              getOptionLabel={(option) => option.name}
              onChange={(e, val) =>
                updateInputObject("branch", val ? val.name : "")
              }
              renderInput={(params) => <TextField {...params} label="Branch" />}
            />

            {/* Employee */}
            <Autocomplete
              multiple
              limitTags={1}
              size="small"
              disableCloseOnSelect
              fullWidth
              options={[{ id: "ALL", name: "Select All" }, ...employeesData]}
              isOptionEqualToValue={(opt, val) => opt.id === val.id}
              getOptionLabel={(option) =>
                option.id === "ALL"
                  ? "Select All"
                  : `${option.employeesCode ? option.employeesCode + " - " : ""
                  }${option.name}`
              }
              value={employeesData.filter((emp) =>
                inputStates.employeeIds?.includes(emp.id)
              )}
              onChange={(e, selected) => {
                const all = selected.some((opt) => opt.id === "ALL");
                updateInputObject(
                  "employeeIds",
                  all
                    ? employeesData.map((e) => e.id)
                    : selected.map((e) => e.id)
                );
              }}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox
                    sx={{ mr: 1 }}
                    checked={
                      option.id === "ALL"
                        ? inputStates.employeeIds?.length ===
                        employeesData.length
                        : selected
                    }
                  />
                  {option.id === "ALL"
                    ? "Select All"
                    : `${option.employeesCode ? option.employeesCode + " - " : ""
                    }${option.name}`}
                </li>
              )}
              renderInput={(params) => (
                <TextField {...params} label="Employee" />
              )}
            />
          </>
        )}

        {/* ================= ALWAYS VISIBLE ================= */}

        {/* Leave Types (MULTI) */}
        <Autocomplete
          multiple
          limitTags={1}
          size="small"
          disableCloseOnSelect
          fullWidth
          options={[
            { id: "all", name: "Select All" },
            { id: 1, name: "Sick Leave" },
            { id: 2, name: "Casual Leave" },
            { id: 3, name: "Privileged Leave" },
            { id: 4, name: "Maternity Leave" },
            { id: 5, name: "Paternity Leave" },
            { id: 7, name: "Menstrual Leave" },
          ]}
          value={[
            { id: 1, name: "Sick Leave" },
            { id: 2, name: "Casual Leave" },
            { id: 3, name: "Privileged Leave" },
            { id: 4, name: "Maternity Leave" },
            { id: 5, name: "Paternity Leave" },
            { id: 7, name: "Menstrual Leave" },
          ].filter((opt) => inputStates.leaveTypes?.includes(opt.name))}
          isOptionEqualToValue={(o, v) => o.id === v.id}
          onChange={(e, values) => {
            if (values.find((v) => v.id === "all")) {
              updateInputObject(
                "leaveTypes",
                inputStates.leaveTypes?.length === 6
                  ? []
                  : [
                    "Sick Leave",
                    "Casual Leave",
                    "Privileged Leave",
                    "Maternity Leave",
                    "Paternity Leave",
                    "Menstrual Leave",
                  ]
              );
              return;
            }
            updateInputObject(
              "leaveTypes",
              values.map((v) => v.name)
            );
          }}
          getOptionLabel={(option) =>
            option.id === "all" ? "Select All" : option.name
          }
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                sx={{ mr: 1 }}
                checked={
                  option.id === "all"
                    ? inputStates.leaveTypes?.length === 6
                    : selected
                }
              />
              {option.id === "all" ? "Select All" : option.name}
            </li>
          )}
          renderInput={(params) => (
            <TextField {...params} label="Leave Types" />
          )}
        />

        {/* As On Date */}
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="As On Date"
            value={inputStates.toDate || null}
            onChange={(val) => updateInputObject("toDate", val)}
            slotProps={{ textField: { size: "small", fullWidth: true } }}
          />
        </LocalizationProvider>

        {/* Search Button */}
        <div className="flex items-end">
          <SearchToggleButton
            searched={searched}
            onSearch={handleSearch}
            onClear={clearSearch}
          />
        </div>
      </div>

      {(permissions.pdfDownload || permissions.allAccess) && (
        <>
          <br />
          <br />
          <div
            className="mb-5"
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "16px",
              alignItems: "flex-start",
            }}
          >
            <div
              style={{
                flex: "1 1 250px",
                maxWidth: "300px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <AddButton
                label="Download PDF"
                id="quotation_view_generatepdf"
                onClick={() => {
                  setLoading(true); // show loader immediately

                  requestAnimationFrame(() => {
                    generateLeaveReport({
                      leaveManagementList,
                      headers,
                      letterHead,
                    });
                  });
                }}
              />
            </div>
          </div>
        </>
      )}
      <br />

      <ListView
        headers={headers}
        data={leaveManagementList}
        actions={
          {
            //   edit: handleEdit,
            //   delete: handleDelete,
          }
        }
        // showCheckbox={true} //enable checkbox
        // deleteTableName={"leaveManagement"}
        moduleId={props.moduleId}
        totalRows={leaveManagementList?.length}
        rowsPerPageOptions={[-1]}
      />

      <LoaderModal loading={loading} />
    </>
  );
};

export default LeaveBalanceReport;
